'use strict';
import $ from 'jquery';

export default class Marketo {
    constructor() {
        let self = this;
        if ($('form[data-marketo-form]').length) {
            $('form[data-marketo-form]').each(function () {
                let $form = $(this);
                let form_id = $form.data('marketo-form');
                MktoForms2.loadForm("//go.open-systems.com", "121-DOQ-259", form_id);
            });
        }

        if ('object' === typeof MktoForms2) {
            MktoForms2.whenReady(function (form) {
                let $form = $(form.getFormElem());

                form.onValidate(function () {
                    var email = form.vals().Email;
                    if (email) {
                        if (!self.isEmailGood(email)) {
                            form.submitable(false);
                            var emailElem = form.getFormElem().find("#Email");
                            form.showErrorMessage("Must be Business email.", emailElem);
                        } else {
                            form.submitable(true);
                        }
                    }
                });

                $form.trigger('formReady');
                form.onSuccess(function (values, followUpUrl) {
                    $form.trigger('submitSuccess', [values, followUpUrl]);
                    return false;
                });
            });
        }
    }

    // end ready

    // let invalidDomains = ["@gmail.","@yahoo.","@hotmail.","@live.","@aol.","@outlook."];

    isEmailGood(email) {
        let invalidDomains = ["@gmail.", "@yahoo.", "@hotmail.", "@live.", "@aol.", "@outlook.", "@mailinator.", "@bt.", "@att.", "@orange."];
        for (var i = 0; i < invalidDomains.length; i++) {
            var domain = invalidDomains[i];
            if (email.indexOf(domain) != -1) {
                return false;
            }
        }
        return true;
    }
}